const Array_Methods_Pratice_2 = () => {
    return (
      <div>
        <h1>Array Methods Pratice 2</h1>
      </div>
    );
  };
  export default Array_Methods_Pratice_2;
  